export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20fashion%20lifestyle%20scene%20with%20carefully%20arranged%20clothing%20on%20a%20light%20linen%20surface%2C%20a%20pair%20of%20cream%20white%20designer%20sneakers%20with%20subtle%20olive%20green%20accents%20placed%20centrally%2C%20a%20folded%20soft%20beige%20cashmere%20sweater%20beside%20them%2C%20delicate%20gold%20toned%20accessories%20scattered%20naturally%2C%20a%20steaming%20ceramic%20coffee%20cup%20in%20the%20background%2C%20soft%20diffused%20morning%20light%20through%20sheer%20curtains%2C%20elegant%20Scandinavian%20interior%20with%20warm%20wooden%20textures%2C%20editorial%20product%20photography%2C%20high%20key%20bright%20airy%20atmosphere%2C%20organic%20composition%20with%20gentle%20shadows&width=1800&height=1200&seq=hero-bg-v2-01&orientation=landscape"
          alt="OOPBUY Spreadsheet Lifestyle"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/18 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 pt-20 pb-16 flex flex-col items-center text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <span className="w-2 h-2 rounded-full bg-primary-400"></span>
          <span className="text-background-50 text-xs font-medium tracking-wide">DER ULTIMATIVE GUIDE 2026</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 font-bold leading-tight max-w-4xl tracking-tight">
          OOPBUY Spreadsheet
          <br />
          <span className="font-light italic">Ihr smarter Einkaufsbegleiter</span>
        </h1>

        <p className="mt-6 text-background-50/80 text-base md:text-lg max-w-2xl leading-relaxed">
          Entdecken Sie den vollständigen OOPBUY Spreadsheet Guide mit allen Kategorien, QC-Tipps, 
          Versandinformationen und den besten Spreadsheet-Vorlagen für Deutschland, Österreich und die Schweiz.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 bg-primary-500 text-background-50 text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap hover:scale-105"
          >
            OOPBUY Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 bg-background-50/15 backdrop-blur-sm text-background-50 text-base font-medium rounded-full border border-background-50/30 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap hover:scale-105"
          >
            Buy it now
          </a>
        </div>

        <div className="mt-16 flex items-center gap-8">
          <div className="text-center">
            <div className="text-background-50 text-2xl md:text-3xl font-bold font-heading">14+</div>
            <div className="text-background-50/60 text-xs mt-1">Kategorien</div>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-background-50 text-2xl md:text-3xl font-bold font-heading">100%</div>
            <div className="text-background-50/60 text-xs mt-1">Kostenlos</div>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-background-50 text-2xl md:text-3xl font-bold font-heading">DACH</div>
            <div className="text-background-50/60 text-xs mt-1">Region</div>
          </div>
        </div>

        <div className="mt-16 animate-bounce">
          <i className="ri-arrow-down-line text-background-50/50 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}